import "./EnquiryButton.css";

export default function EnquiryButton() {
  const handleClick = () => {
    // scroll to contact section
    document
      .getElementById("contact")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="enquiry-button" onClick={handleClick}>
      ENQUIRE NOW
    </div>
  );
}

// import "./EnquiryButton.css";

// export default function EnquiryButton({ onClick }) {
//   return (
//     <div className="enquiry-button" onClick={onClick}>
//       ENQUIRE NOW
//     </div>
//   );
// }
